import entityService from "../../services/entityService";

export default {
  load
};

function load({ rootState, commit }) {
  return new Promise((resolve, reject) => {
    commit("setPendingStateChanges", 1);
    entityService
      .getAll(rootState.tenantId)
      .then(results => {
        results = sortEntities(results);
       
        commit("set", results);
        resolve(JSON.parse(JSON.stringify(results)));
      }, reject)
      .finally(() => {
        commit("setPendingStateChanges", -1);
      });
  });
}

function sortEntities(arr) {
  return arr
    .map(x => {
      if (x.children) x.children = sortEntities(x.children);
      return x;
    })
    .sort((a, b) => {
      var test1 = a.name.toUpperCase();
      var test2 = b.name.toUpperCase();

      if (test1 < test2) return -1;
      if (test1 > test2) return 1;
      return 0;
    });
}

export function padEntityId(id) {
  return id.length < 4 ? id.padEnd(6, "0") : id;
}
